import styled, { css } from 'styled-components';

import { StyledForm } from '../../components/Cigarette/styles';

export const Container = styled.div<{ $isBlankBackground?: boolean; $isMobile?: boolean }>`
  /* не перекрывать раскрытое меню другой сигареты */
  & > form {
    z-index: auto;
  }

  & > form div.lt-departure-picker__control {
    border-radius: 0;
  }

  ${({ $isBlankBackground }) => !$isBlankBackground && backgroundStyles}

  ${({ $isMobile, $isBlankBackground }) =>
    !$isBlankBackground && $isMobile && mobileBackgroundStyles}

  ${({ $isMobile, $isBlankBackground }) =>
    !$isBlankBackground && !$isMobile && desktopBackgroundStyles}

  & ${StyledForm} {
    ${({ $isBlankBackground }) =>
      $isBlankBackground &&
      `
      background-color: #fff;
    `}
  }

  & span {
    ${({ $isBlankBackground }) =>
      $isBlankBackground &&
      `
      color: #4d4d4d;
    `}
  }
`;

export const ContainerCigarette = styled.div`
  max-width: 1200px;
  margin: auto;
`;

const backgroundStyles = css`
  background: #4d4d4d;
  border-radius: 4px;
  max-width: 1200px;
  padding: 8px;
  margin: auto;
`;

const mobileBackgroundStyles = css`
  & > form {
    background-color: #4d4d4d;
  }
`;

const desktopBackgroundStyles = css`
  & > form > div:last-child {
    padding: 9px 8px;
  }
`;
